import { Configuration, TradeServiceApi } from '@fintronners/react-api/src';
import RuntimeEnvGRPCAPI from '@/utils/RuntimeEnvGRPCAPI';
import { useGrpcApiV1Config } from '@/hooks/api/useGrpcApiV1Config';

const useTradeApiService = () => {
  const { basePath, accessToken } = useGrpcApiV1Config();

  const tradeApiService = RuntimeEnvGRPCAPI.getV1Service(
    TradeServiceApi,
    new Configuration({
      basePath,
      accessToken,
      baseOptions: {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    }),
  );

  return tradeApiService;
};

export default useTradeApiService;
